import { useTheme } from '@classify/react-core-components/styles';

import statuses from '../constants/statuses';

function useColorByStatus(status) {
  const { palette } = useTheme();

  const colorMap = {
    notStarted: [
      statuses.STATUS_NOT_STARTED,
      statuses.STATUS_PENDING,
      statuses.STATUS_CANCELED,
      statuses.STATUS_LATE_CANCELED,
      statuses.STATUS_NOT_FOLLOWED,
    ],
    success: [statuses.STATUS_PASSED, statuses.STATUS_READY_FOR_REVIEW, statuses.STATUS_COMPLETED],
    fail: [statuses.STATUS_FAILED, statuses.STATUS_STUDENT_ABSENT, statuses.STATUS_CRITICALLY_LATE],
    awaiting: [statuses.STATUS_AWAITING_REVIEW, statuses.STATUS_ON_TRACK_IN_ADVANCE],
    retry: [
      statuses.STATUS_CAN_RETRY,
      statuses.STATUS_LATE,
      statuses.STATUS_ON_TRACK_SLIGHTLY_LATE,
    ],
    inProgress: [statuses.STATUS_IN_PROGRESS, statuses.STATUS_IN_ADVANCE, statuses.STATUS_FOLLOWED],
  };

  let colorToReturn = 'notStarted';

  Object.entries(colorMap).forEach(([color, statusesMap]) => {
    if (statusesMap.includes(status)) {
      colorToReturn = color;
    }
  });

  return palette.status[colorToReturn];
}

export default useColorByStatus;
